const utils = {};
const accuracy = require('../../../utils/accuracy').default;
// 保险期限
utils.guarantPre = [
  {
    key: 1,
    value: '1个月'
  },
  {
    key: 2,
    value: '2个月'
  },
  {
    key: 3,
    value: '3个月'
  },
  {
    key: 4,
    value: '4个月'
  },
  {
    key: 5,
    value: '5个月'
  },
  {
    key: 6,
    value: '6个月'
  },
  {
    key: 7,
    value: '7个月'
  },
  {
    key: 8,
    value: '8个月'
  },
  {
    key: 9,
    value: '9个月'
  },
  {
    key: 10,
    value: '10个月'
  },
  {
    key: 11,
    value: '11个月'
  },
  {
    key: 12,
    value: '12个月'
  }
];
// 扩展残疾鉴定国家工伤标准
utils.KZSCOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 1,
    name: '附加'
  }
];
utils.occupationNumberList = [
  {
    occupationKind: '1',
    personNum: 0
  },
  {
    occupationKind: '2',
    personNum: 0
  },
  {
    occupationKind: '3',
    personNum: 0
  },
  {
    occupationKind: '4',
    personNum: 0
  },
  {
    occupationKind: '5',
    personNum: 0
  },
  {
    occupationKind: '6',
    personNum: 0
  }
];
utils.planOptions = [
  {
    value: 'GFTYX20Hone',
    name: 'A版'
  },
  {
    value: 'GFTYX20Htwo',
    name: 'F版'
  }
];
utils.sexOptions = [
  {
    name: '男',
    value: 'M'
  },
  {
    name: '女',
    value: 'F'
  }
];
//职业分类
utils.occupationOptionsLevel = [
  {
    value: '1',
    name: '1类'
  },
  {
    value: '2',
    name: '2类'
  },
  {
    value: '3',
    name: '3类'
  },
  {
    value: '4',
    name: '4类'
  },
  {
    value: '5',
    name: '5类'
  }
];
utils.SWCJOptions = [
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  },
  {
    value: 600000,
    name: '60万'
  },
  {
    value: 700000,
    name: '70万'
  },
  {
    value: 800000,
    name: '80万'
  },
  {
    value: 900000,
    name: '90万'
  },
  {
    value: 1000000,
    name: '100万'
  }
];
utils.JCYWOptions = [
  {
    value: 0,
    name: '0'
  },
  {
    value: 50000,
    name: '5万'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 150000,
    name: '15万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 250000,
    name: '25万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 350000,
    name: '35万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 450000,
    name: '45万'
  },
  {
    value: 500000,
    name: '50万'
  }
];
utils.oneSCOptions = [
  {
    value: 0,
    name: '0'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  },
  {
    value: 600000,
    name: '60万'
  },
  {
    value: 700000,
    name: '70万'
  },
  {
    value: 800000,
    name: '80万'
  },
  {
    value: 900000,
    name: '90万'
  },
  {
    value: 1000000,
    name: '100万'
  }
];
utils.KYQCYWOptions = [
  {
    value: 0,
    name: '0'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  }
];
utils.YLFYOptions = [
  {
    value: 0,
    name: '不附加',
    disabled: false
  },
  {
    value: 10000,
    name: '1万',
    disabled: false
  },
  {
    value: 20000,
    name: '2万',
    disabled: false
  },
  {
    value: 30000,
    name: '3万',
    disabled: false
  },
  {
    value: 40000,
    name: '4万',
    disabled: false
  },
  {
    value: 50000,
    name: '5万',
    disabled: false
  },
  {
    value: 60000,
    name: '6万',
    disabled: false
  },
  {
    value: 70000,
    name: '7万',
    disabled: false
  },
  {
    value: 80000,
    name: '8万',
    disabled: false
  },
  {
    value: 90000,
    name: '9万',
    disabled: false
  },
  {
    value: 100000,
    name: '10万',
    disabled: false
  }
];
(utils.companyCatagoryList = [
  { value: 'A01', text: '农业' },
  { value: 'A02', text: '林业' },
  { value: 'A03', text: '畜牧业' },
  { value: 'A04', text: '渔业' },
  { value: 'A05', text: '农、林、牧、渔服务业' },
  { value: 'B06', text: '煤炭开采与洗选业' },
  { value: 'B07', text: '石油和天然气开采业' },
  { value: 'B08', text: '黑色金属矿采选业' },
  { value: 'B09', text: '有色金属矿采选业' },
  { value: 'B10', text: '非金属矿采选业' },
  { value: 'B11', text: '其他矿采选业' },
  { value: 'C13', text: '农副食品加工业' },
  { value: 'C14', text: '食品制造业' },
  { value: 'C15', text: '饮料制造业' },
  { value: 'C16', text: '烟草制品业' },
  { value: 'C17', text: '纺织业' },
  { value: 'C18', text: '纺织服装、鞋、帽制造业' },
  { value: 'C19', text: '皮革、毛皮、羽毛（绒）及其制品业' },
  { value: 'C20', text: '木材加工及木、竹、藤、棕、草制品业' },
  { value: 'C21', text: '家具制造业' },
  { value: 'C22', text: '造纸及纸制品业' },
  { value: 'C23', text: '印刷业、记录媒介的复制' },
  { value: 'C24', text: '文教体育用品制造业' },
  { value: 'C25', text: '石油加工、炼焦及核燃料加工业' },
  { value: 'C26', text: '化学原料及化学制品制造业' },
  { value: 'C27', text: '医药制造业' },
  { value: 'C28', text: '化学纤维制造业' },
  { value: 'C29', text: '橡胶制品业' },
  { value: 'C30', text: '塑料制品业' },
  { value: 'C31', text: '非金属矿物制品业' },
  { value: 'C32', text: '黑色金属冶炼及压延加工业' },
  { value: 'C33', text: '有色金属冶炼及压延加工业' },
  { value: 'C34', text: '金属制品业' },
  { value: 'C35', text: '通用设备制造业' },
  { value: 'C36', text: '专业设备制造业' },
  { value: 'C37', text: '交通运输设备制造业' },
  { value: 'C39', text: '电气机械及器材制造业' },
  { value: 'C40', text: '通信设备、计算机及其他电子设备制造业' },
  { value: 'C41', text: '仪器仪表及文化、办公用机械制造业' },
  { value: 'C42', text: '工艺品及其他制造业' },
  { value: 'C43', text: '废弃资源和废旧材料回收加工业' },
  { value: 'D44', text: '电力、热力的生产和供应业' },
  { value: 'D45', text: '燃气生产和供应业' },
  { value: 'D46', text: '水的生产和供应业' },
  { value: 'E47', text: '房屋和土木工程建筑业' },
  { value: 'E48', text: '建筑安装业' },
  { value: 'E49', text: '建筑装饰业' },
  { value: 'E50', text: '其他建筑业' },
  { value: 'F51', text: '铁路运输业' },
  { value: 'F52', text: '道路运输业' },
  { value: 'F53', text: '城市公共交通业' },
  { value: 'F54', text: '水上运输业' },
  { value: 'F55', text: '航空运输业' },
  { value: 'F56', text: '管道运输业' },
  { value: 'F57', text: '装卸搬运和其他运输服务业' },
  { value: 'F58', text: '仓储业' },
  { value: 'F59', text: '邮政业' },
  { value: 'G60', text: '电信和其他信息传输服务业' },
  { value: 'G61', text: '计算机服务业' },
  { value: 'G62', text: '软件业' },
  { value: 'H63', text: '批发业' },
  { value: 'H65', text: '零售业' },
  { value: 'I66', text: '住宿业' },
  { value: 'I67', text: '餐饮业' },
  { value: 'J68', text: '银行业' },
  { value: 'J69', text: '证券业' },
  { value: 'J70', text: '保险业' },
  { value: 'J71', text: '其他金融活动' },
  { value: 'K72', text: '房地产业' },
  { value: 'L73', text: '租赁业' },
  { value: 'L74', text: '商务服务业' },
  { value: 'M75', text: '研究与试验发展' },
  { value: 'M76', text: '专业技术服务业' },
  { value: 'M77', text: '科技交流和推广服务业' },
  { value: 'M78', text: '地质勘查业' },
  { value: 'N79', text: '水利管理业' },
  { value: 'N80', text: '环境管理业' },
  { value: 'N81', text: '公共设施管理业' },
  { value: 'O82', text: '居民服务业' },
  { value: 'O83', text: '其他服务业' },
  { value: 'P84', text: '教育' },
  { value: 'Q85', text: '卫生' },
  { value: 'Q86', text: '社会保障业' },
  { value: 'Q87', text: '社会福利业' },
  { value: 'R88', text: '新闻出版业' },
  { value: 'R89', text: '广播、电视、电影和音像业' },
  { value: 'R90', text: '文化艺术业' },
  { value: 'R91', text: '体育' },
  { value: 'R92', text: '娱乐业' },
  { value: 'S93', text: '中国共产党机关' },
  { value: 'S94', text: '国家机构' },
  { value: 'S95', text: '人民政协和民主党派' },
  { value: 'S96', text: '群众团体、社会团体和宗教组织' },
  { value: 'S97', text: '基层群众自治组织' },
  { value: 'T98', text: '国际组织' },
  { value: 'U99', text: '其他' }
]),
  (utils.columns = [
    {
      title: '序号',
      scopedSlots: { customRender: 'num' }
    },
    {
      title: '被保险人姓名',
      dataIndex: 'name'
    },
    {
      title: '证件类型',
      dataIndex: 'idType',
      key: 'idType',
      scopedSlots: { customRender: 'idType' }
    },
    {
      title: '证件号码',
      dataIndex: 'idNumber'
    },
    {
      title: '国籍',
      dataIndex: 'nationality',
      key: 'nationality',
      scopedSlots: { customRender: 'nationality' }
    },
    {
      title: '出生日期',
      dataIndex: 'birthDate'
    },
    {
      title: '性别',
      dataIndex: 'gender',
      key: 'gender',
      scopedSlots: { customRender: 'gender' }
    },
    {
      title: '职业',
      dataIndex: 'occupationName'
    },
    {
      title: '职业类别代码',
      dataIndex: 'occupationCode'
    },
    {
      title: '职业大类',
      dataIndex: 'occulevel',
      key: 'occulevel',
      scopedSlots: { customRender: 'occulevel' }
    },
    {
      title: '个人保费',
      dataIndex: 'premium'
    }
  ]);
utils.companyIdTypeOptions = [
  {
    value: '01',
    name: '组织机构代码证'
  },
  {
    value: '04',
    name: '营业执照'
  },
  {
    value: '02',
    name: '税务登记证'
  },
  {
    value: '99',
    name: '其他'
  }
];
//处理证件类型
utils.getterIdtype = function(value) {
  switch (value) {
    case '身份证':
    case '01':
    case 1:
    case '1':
      return '身份证';
    case '护照':
    case '02':
    case '2':
    case 0:
      return '护照';
    case '其它':
    case '99':
    case 99:
      return '其它';
    case '06':
    case '6':
    case 6:
      return '港澳回乡证或台胞证';
    default:
      return '身份证';
  }
};
//处理险种的拼接字段
utils.perRiskInfoNew = function(perRiskInfo) {
  var arrperRiskInfo = [];
  perRiskInfo.forEach(e => {
    if (e.riskCode == 'PL180Y502' && parseFloat(e.amount) > 0) {
      arrperRiskInfo.push('PL180Y502-团体意外伤害保险-CVYA001-意外伤害身故、残疾-' + e.amount + '-' + e.premiumAmt);
    }
    if (e.riskCode == 'PL180J003' && parseFloat(e.amount) > 0) {
      arrperRiskInfo.push('PL180J003-附加意外伤害医疗费用补偿保险-CVJA017-意外医疗费用补偿-' + e.amount + '-' + e.premiumAmt);
    }
    if (e.riskCode == 'PL180J092' && parseFloat(e.amount) > 0) {
      arrperRiskInfo.push('PL180J092-附加意外伤害住院津贴保险-CVJD006-意外住院津贴-' + e.amount + '-' + e.premiumAmt);
    }
    if (e.riskCode == 'PL180Y504' && e.dutyCode == 'CVYA008' && parseFloat(e.amount) > 0) {
      arrperRiskInfo.push('PL180Y504-交通工具意外伤害保险-CVYA008-客运民航客机意外身故残疾-' + e.amount + '-' + e.premiumAmt);
    }
    if (e.riskCode == 'PL180Y504' && e.dutyCode == 'CVYA009' && parseFloat(e.amount) > 0) {
      arrperRiskInfo.push('PL180Y504-交通工具意外伤害保险-CVYA009-客运轨道交通身故、伤残、烧伤-' + e.amount + '-' + e.premiumAmt);
    }
    if (e.riskCode == 'PL180Y504' && e.dutyCode == 'CVYA010' && parseFloat(e.amount) > 0) {
      arrperRiskInfo.push('PL180Y504-平安交通工具意外伤害保险-CVYA010-客运轮船身故、伤残、烧伤' + e.amount + '-' + e.premiumAmt);
    }
    if (e.riskCode == 'PL180Y504' && e.dutyCode == 'CVYA011' && parseFloat(e.amount) > 0) {
      arrperRiskInfo.push('PL180Y504-交通工具意外伤害保险-CVYA011-客运机动车身故、伤残、烧伤' + e.amount + '-' + e.premiumAmt);
    }
    if (e.riskCode == 'PL180Y598' && e.dutyCode == 'CVYA001' && parseFloat(e.amount) > 0) {
      arrperRiskInfo.push('PL180Y598-驾乘意外伤害保险-CVYA001驾驶或乘坐家庭自用车身故、伤残、烧伤' + e.amount + '-' + e.premiumAmt);
    }
    if (e.riskCode == 'PL180J128' && e.dutyCode == 'CVJA044' && parseFloat(e.amount) > 0) {
      arrperRiskInfo.push('PL180J128-平安附加自费药费用补偿保险-CVJA044-全额自费药-' + e.amount + '-' + e.premiumAmt);
    }
    if (e.riskCode == 'PL180J103' && parseFloat(e.amount) > 0) {
      arrperRiskInfo.push('PL180J103-平安猝死疾病保险-CVJB009-猝死-' + e.amount + '-' + e.premiumAmt);
    }
  });

  return arrperRiskInfo.join('#');
};
//过滤身份证信息的公共方法
utils.filterAllINTYPE = function(idType) {
  switch (idType) {
    case '身份证':
    case '01':
    case 1:
    case '1':
      return '01';
    case '护照':
    case '02':
    case '2':
    case 0:
      return '02';
    case '港澳回乡证或台胞证':
    case '06':
    case '6':
    case 6:
      return '06';
    case '其它':
    case '99':
    case 99:
      return '99';
    default:
      return '01';
  }
};

//处理性别
utils.getterGender = function(value) {
  switch (value) {
    case 'M':
    case '男':
      return '男';
    case 'F':
    case '女':
      return '女';
    default:
      return '男';
  }
};
//反转对象
utils.resoverObj = function(obj) {
  var a = {
    '1': 0,
    '2': 0,
    '3': 0,
    '4': 0,
    '5': 0,
    '6': 0
  };
  for (const key in obj) {
    a[key] = obj[key];
  }
  return a;
};
//提交的去重
utils.unique = function(arr, attribute) {
  var new_arr = [];
  var json_arr = [];
  for (var i = 0; i < arr.length; i++) {
    if (new_arr.indexOf(arr[i][attribute]) == -1) {
      //  -1代表没有找到
      new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
      json_arr.push(arr[i]);
    }
  }
  return json_arr;
};

//计算总保费
utils.sumZfeiyong = function(content, riskNumber) {
  var jichu = {
    '1类': 0,
    '2类': 0,
    '3类': 0,
    '4类': 0,
    '5类': 0
  };
  for (const key in content) {
    jichu[key] = accuracy.mul(Number(content[key]), Number(riskNumber[key] || 0));
  }

  return jichu;
};
export default utils;
